import { CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import theme from "../../../assets/theme";
// Material Dashboard 2 PRO React context
import { setLayout, useMaterialUIController } from "../../../Context";
import { MDBox } from "../Components/MDBox";

interface IDashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<IDashboardLayoutProps> = ({
  children
}: IDashboardLayoutProps) => {
  const [controller, dispatch] = useMaterialUIController() as any;
  const { miniSidenav } = controller;

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MDBox
        sx={({ transitions, functions: { pxToRem } }: any) => ({
          position: "relative",
          [theme.breakpoints.up("xl")]: {
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}
      >
        {children}
      </MDBox>
    </ThemeProvider>
  );
}
